// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-filters wm-icon {
  height: 100%;
  margin-right: 6px;
}
wm-filters wm-icon div[appBuildSvg] {
  height: 100%;
  display: flex;
}
wm-filters .filter-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 14px;
  gap: 10px;
  cursor: pointer;
  height: 40px;
  position: relative;
  background: #ffffff !important;
  /* Drop Shadow */
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}
wm-filters .filter-button .dot {
  height: 6px;
  width: 6px;
  background-color: var(--wm-color-primary);
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  top: 25%;
  right: 5%;
}
wm-filters ion-list {
  padding: 0 !important;
}
wm-filters .wm-filters-title {
  line-height: 34px;
}
wm-filters .wm-filter-content {
  position: fixed;
  background-color: rgba(255, 255, 255, 0.8);
  top: calc(2% + 60px + constant(safe-area-inset-top));
  top: calc(2% + 60px + env(safe-area-inset-top));
  right: 1%;
  width: 320px;
  z-index: 1;
}
wm-filters .wm-selected-filters {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: stretch;
  overflow: auto;
}
wm-filters .wm-selected-filters ion-chip {
  order: 0;
  flex: 1 1 auto;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: fit-content;
}
wm-filters .wm-selected-filters ion-chip ion-label {
  order: 0;
  flex: 1 1 auto;
  margin: 0px 2px;
}
wm-filters .wm-selected-filters ion-chip ion-icon,
wm-filters .wm-selected-filters ion-chip i {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
}
wm-filters .wm-selected-filters ion-chip img {
  position: relative;
  height: 25px;
  display: block;
  margin-left: -7px;
  margin-top: -4px;
}

ion-chip {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/filters/filters.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,iBAAA;AAAJ;AACI;EACE,YAAA;EACA,aAAA;AACN;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EAEA,2CAAA;EACA,mBAAA;AADJ;AAEI;EACE,WAAA;EACA,UAAA;EACA,yCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAAN;AAGE;EACE,qBAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAIE;EACE,eAAA;EACA,0CAAA;EACA,oDAAA;EACA,+CAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AAFJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;AAFJ;AAGI;EACE,QAAA;EACA,cAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAFN;AAIM;EACE,QAAA;EACA,cAAA;EACA,eAAA;AAFR;AAIM;;EAEE,QAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAIM;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAFR;;AAQA;EACE,WAAA;AALF","sourcesContent":["wm-filters {\n  wm-icon {\n    height: 100%;\n    margin-right: 6px;\n    div[appBuildSvg] {\n      height: 100%;\n      display: flex;\n    }\n  }\n  .filter-button {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 14px;\n    gap: 10px;\n    cursor: pointer;\n    height: 40px;\n    position: relative;\n    background: #ffffff !important;\n    /* Drop Shadow */\n\n    box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);\n    border-radius: 20px;\n    .dot {\n      height: 6px;\n      width: 6px;\n      background-color: var(--wm-color-primary);\n      border-radius: 50%;\n      display: inline-block;\n      position: absolute;\n      top: 25%;\n      right: 5%;\n    }\n  }\n  ion-list {\n    padding: 0 !important;\n  }\n\n  .wm-filters-title {\n    line-height: 34px;\n  }\n  .wm-filter-content {\n    position: fixed;\n    background-color: rgba($color: white, $alpha: 0.8);\n    top: calc(2% + 60px + constant(safe-area-inset-top));\n    top: calc(2% + 60px + env(safe-area-inset-top));\n    right: 1%;\n    width: 320px;\n    z-index: 1;\n  }\n  .wm-selected-filters {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-content: stretch;\n    align-items: stretch;\n    overflow: auto;\n    ion-chip {\n      order: 0;\n      flex: 1 1 auto;\n      align-self: stretch;\n\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n      min-width: fit-content;\n\n      ion-label {\n        order: 0;\n        flex: 1 1 auto;\n        margin: 0px 2px;\n      }\n      ion-icon,\n      i {\n        order: 0;\n        flex: 0 1 auto;\n        align-self: center;\n      }\n      img {\n        position: relative;\n        height: 25px;\n        display: block;\n        margin-left: -7px;\n        margin-top: -4px;\n      }\n    }\n  }\n}\n\nion-chip {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
